const portland = portland || {};

(function ($, history, URLSearchParams) {

	portland.issues = {

		elem: {
			$articles: $('.article-grid'),
			$loading: $('.loader'),
			$pagination: $('.pagination'),
			$results: $('.results')
		},

		mql: {
			large: window.matchMedia('(min-width: 640px)')
		},

		// Filters

		dataSrc:  $('.results').data('src'),
		documentRoot: '/portlandmagazineredesign',
		paginator: '/_files/_data/paginator.php',
		//documentRoot: '/data',
		//paginator: '/' + $('.results').data('src'),
		pagesize: 12,

		results: '',

		filters: {
			pageindex: 0
		},

		// Initialize Function
		init: function () {
			this.getQuery();
			this.setQuery(false, false);
			window.onpopstate = this.filterState;
		},

		// Build a querystring from a filter object
		buildQuery: function() {
			let data = portland.issues.filters;
			let query = [];
			for (let key in data) {
				if (data.hasOwnProperty(key)) {
					if (Array.isArray(key)) {
						data[key] = key.toString();
					}
					query.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
				}
			}
			query = query.join('&').replace(/%2C/g, ',');
			return query;
		},

		// Pagination filtering
		filterPagination: function(e) {
			e.preventDefault();
			portland.issues.filters['pageindex'] = e.currentTarget.hash.substr(1);
			portland.issues.setQuery(true, true);
		},

		// PopState filtering
		filterState: function() {
			portland.issues.getQuery();
			portland.issues.setQuery(false, false);
		},

		// Get Data
		getData: function(query) {
			let deferred = $.Deferred();
			$.ajax({
				url: portland.issues.documentRoot + portland.issues.paginator + '?datasrc=' + portland.issues.dataSrc,
				method: 'GET',
				data: query,
				dataType: 'html',
				success: function(data) {
					deferred.resolve(data);
				},
				error: function(jqXHR, textStatus, errorThrow) {
					console.log(jqXHR, errorThrow);
					deferred.reject(textStatus);
				}
			});
			return deferred.promise();
		},

		// Get filters from existing query string
		getQuery: function() {
			if (window.location.search.length > 0) { 
				let searchParams = new URLSearchParams(window.location.search);
				searchParams.forEach(function (value,key) {
					if(value !== '') {
						if (Array.isArray(portland.issues.filters[key])) {
							portland.issues.filters[key] = [];
							value = value.split(',');
							portland.issues.filters[key] = value;
						} else {
							portland.issues.filters[key] = value;
						}
					}
				});
			}
		},

		// Build pagination
		renderPagination: function() {
			let items = [];
			let filters = portland.issues.filters;
			let current = parseInt(filters['pageindex']);
			let max = Math.ceil(parseInt(portland.issues.results[0].TotalCount) / parseInt(portland.issues.pagesize)) - 1;
			let output = '<div class="pagination__column column small-12 large-10 large-push-1"><ul class="pagination__list">';
			// Push all the items we need at a minimum: first, current, last, and output bracketing current
			items.push(0, current - 1, current, current + 1, max);
			// When the values are close to first or last, push some extra options to ensure that we always have at least four options showing
			if (current < 2) {
				items.push(2);
			}
			if (current > (max - 1)) {
				items.push(max - 2);
			}
			// Filter out results that are less than zero, or greater than max, then sort
			items = items.filter(function(x){ return x > -1 });
			items = items.filter(function(x){ return x <= max });
			items.sort(function(a, b){return a-b});

			if(current !== 0) {
				output += '<li class="pagination__item pagination__item--prev"><a href="#' + (current - 1) + '" rel="prev" class="pagination__button" aria-label="Previous Page"><svg class="icon icon-arrow-left" focusable="false"><use xlink:href="#icon-arrow-left"></use></svg></a></li>';
			}
			for(let i = 0; i < items.length; i = i + 1) {
				if((i === 0) || (items[i] !== items[i - 1])) {
					if((i > 0) && ((items[i] - items[i - 1]) > 1)) {
						output += '<li class="pagination__item">...</li>';
					}
					if(items[i] === current) {
						output += '<li class="pagination__item"><a href="#' + items[i] + '" class="pagination__link pagination__link--active">' + (items[i] + 1) + '</a></li>';
					} else {
						output += '<li class="pagination__item"><a href="#' + items[i] + '" class="pagination__link">' + (items[i] + 1) + '</a></li>';
					}
				}
			}
			if(current !== max) {

				output += '<li class="pagination__item pagination__item--next"><a href="#' + (current + 1) + '" rel="next" class="pagination__button" aria-label="Next Page"><svg class="icon icon-arrow-right" focusable="false"><use xlink:href="#icon-arrow-right"></use></svg></a></li>';
			}
			output += '</ul></div>';
			portland.issues.elem.$pagination.html(output);
			$('.pagination__button, .pagination__link').on('click', portland.issues.filterPagination);
		},

		renderResults: function() {
			portland.issues.elem.$loading.hide();
			if((portland.issues.results !== '') && (portland.issues.results[0].TotalCount > 0)) {7
				let output = '';
				portland.issues.results[0].Results.forEach( function(item) {
					output += '<div class="issue"><img src="' + portland.issues.documentRoot + item.image.src + '" alt="' + item.image.alt + '" class="issue__image"><h2 class="issue__title h5">' + item.title + '</h2><a href="' + portland.issues.documentRoot + item.url + '" class="issue__link" aria-label="Read ' + item.title + ' Issue"></a></div>';
				});
				portland.issues.elem.$results.html(output).fadeIn();
				if(portland.issues.results[0].TotalCount > portland.issues.pagesize) {
					portland.issues.renderPagination();
					portland.issues.elem.$pagination.fadeIn();
				}
			} else {
				portland.issues.elem.$results.html('<p">No matching articles were found.</p>').fadeIn();
			}
		},

		// Set the current URL to 
		setQuery: function (reposition, push) {
			let query = portland.issues.buildQuery();
			let dataObj = portland.issues.getData(query);
			if (reposition === true) {
				$('html, body').animate({ scrollTop: $('.results').offset().top }, 400);
			}
			if (push === true) {
				history.pushState(null, '', '?' + query);
			} else {
				history.replaceState(null, '', '?' + query);
			}
			portland.issues.elem.$loading.show();
			portland.issues.elem.$results.fadeOut().empty();
			portland.issues.elem.$pagination.fadeOut().empty();
			$.when(dataObj)
				.done(function(data) {
					setTimeout(function() {
						if(data !== '') {
							portland.issues.results = JSON.parse(data);
						} else {
							portland.issues.results = ''
						}
						portland.issues.renderResults();
					}, 500);
				})
				.fail(function () {
					console.log('API ERROR: No results were returned')
				});
		}

	};

}(window.jQuery, window.history, window.URLSearchParams));

const ready = () => {
	portland.issues.init();
};

window.addEventListener('DOMContentLoaded', ready, false);
$(document).foundation();
